import React, { useState } from 'react'; // Import useState
import { Link } from 'react-router-dom';
import MegaMenu from '../megaMenu/megaMenu';
import './nav.css';
import { STAGE_ADMIN } from '../../../../Constants';
import moengage from "@moengage/web-sdk";
import Cookies from "js-cookie";

const Navigation = ({ setDisplayProductList }) => {
  const [isMegaMenuActive, setMegaMenuActive] = useState(false);

  // Functions to handle hover state
  const handleMouseEnter = () => {
    setMegaMenuActive(true);
  };

  const handleMouseLeave = () => {
    setMegaMenuActive(false);
  };
  const handleMoengageEvent = () => {
 
		moengage.track_event("UnfitMart_Store_Viewed", {
			"ID": (Cookies.get("Otp")) ? `+91${JSON.parse(Cookies.get("Otp")).MobileNo}` :"", 


		  });  	
	}
  return (
    <nav className="main__header__wrapper navbar">
      <ul className="brand__menu">
        {/* Single menu item with hover functionality */}
        <li
          className="mega-menu-item"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Link to={window.location.href}>Brands</Link>
          {/* Pass the active prop based on hover state */}
          <MegaMenu active={isMegaMenuActive} />
        </li>

        {/* Additional menu items */}
        {STAGE_ADMIN && (
          <li className="mega-menu-item">
            <Link to="/blogs/all-blogs">Blogs</Link>
          </li>
        )}
        {/* Devarsh */}
            <li className="mega-menu-item">
              <Link to="/unfit-store" onClick={handleMoengageEvent}>unFIT Store</Link>
            </li>

      </ul>
    </nav>
  );
};

export default Navigation;
